import { render, staticRenderFns } from "./AuthCard.vue?vue&type=template&id=3485f31e&scoped=true&"
import script from "./AuthCard.vue?vue&type=script&lang=ts&"
export * from "./AuthCard.vue?vue&type=script&lang=ts&"
import style0 from "./AuthCard.vue?vue&type=style&index=0&id=3485f31e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3485f31e",
  null
  
)

export default component.exports